;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .factory('csSendVulnService', ['$uibModal', csSendVulnService])

  function csSendVulnService($uibModal) {
    var service = {
      open: open
    }

    return service

    function open(options) {
      var modalOpts = {
        templateUrl: 'views/cs-send-vuln.html',
        controller: 'csSendVulnCtrl',
        controllerAs: 'csSendVulnCtrl',
        size: 'md',
        backdrop: 'static'
      }
      if (angular.isObject(options)) {
        modalOpts = angular.extend(modalOpts, options)
      }
      return $uibModal.open(modalOpts)
    }
  }
})()
